<template>
  <div
    class="cat-item"
    :style="myMenuStyle"
  >
    <v-container>
      <v-layout
        row
        align-center
      >
        <v-flex 
          xs12
          text-xs-center
        >
          <v-icon :color="!fromCustomSets ? theme.menu_subtitle_color : ''">bubble_chart</v-icon>
          <span :style="myNameStyle">{{ $t('no_item') }}</span>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'no-cat-item-component',
  props: {
    fromCustomSets: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    myMenuStyle () {
      if (this.fromCustomSets) {
        return {
          backgroundColor: this.theme.login_bg_color
        }
      }
      return {
        backgroundColor: this.theme.submenu_bg_color,
        borderTop: `8px solid ${this.theme.bg_color}`,
        borderBottom: `8px solid ${this.theme.bg_color}`
      }
    },
    myNameStyle () {
      if (this.fromCustomSets) {
        return {
          fontSize: '15px'
        }
      }
      return {
        color: this.theme.menu_subtitle_color,
        fontWeight: 700,
        fontSize: '17px'
      }
    }
  }
}
</script>

<style scoped>
.cat-item {
  min-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/NoCatItem.vue